const  mutations = {
    setseleccionados(state,seleccionados){
        state.seleccionados = seleccionados;
    },
    setmasutilizados (state, masutilizados) {
        state.masutilizados = masutilizados;
    }
}; 

export default mutations;